import { Injectable } from '@angular/core';
import { IParallelTasksData, parallelTasksQueue } from '@fi-shared/utils/parallel-tasks-queue';

export enum FiBackendRequestType {
    InitialData = 0,
    WidgetSitemap,
    WidgetItemsList,
    WidgetFormListing,
    WidgetForumListing,
    WidgetForumFeed,
}

const NUMBER_OF_SIMULTANEOUS_REQUESTS = 4;

@Injectable()
export class FiRequestsQueueService {
    private requestsQueue: IParallelTasksData;

    constructor() {
        this.requestsQueue = parallelTasksQueue(NUMBER_OF_SIMULTANEOUS_REQUESTS);
    }

    addRequestToQueue(requestFn: () => Promise<void>, requestType: FiBackendRequestType) {
        this.requestsQueue.add(requestFn);
    }
}
